import './HistogramSelectionArea.css';
export var histogramSelectionArea = '_1go6afd0-2-0-1';